import { render } from "./g-payment_stripe-card.vue?vue&type=template&id=216fbb30&ts=true"
import script from "./g-payment_stripe-card.vue?vue&type=script&lang=tsx"
export * from "./g-payment_stripe-card.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__